import type { SchemaBuilderExpressionVariableProps } from "./schema-builder-expression-variable.type";

import { useTranslation } from "react-i18next";

import { FieldSelect } from "@/ui/field-select";
import { FieldText } from "@/ui/field-text";
import { TextEllipsis } from "@/ui/text-ellipsis";

import { useSchemaBuilderFieldContext } from "../../schema-builder-field";

export const SchemaBuilderExpressionVariable = ({
  variable,
  field,
}: SchemaBuilderExpressionVariableProps) => {
  const { t } = useTranslation();
  const { formFieldsNumber } = useSchemaBuilderFieldContext();
  const varName = variable?.variable ?? "";

  return (
    <>
      <TextEllipsis
        text={varName}
        length={20}
        className="schema-builder-expression-variable-name"
      />
      <div className="schema-builder-expression-variable-select">
        <FieldText name={[field.name, "variable"]} hidden />
        <FieldSelect
          label={varName}
          name={[field.name, "model"]}
          options={formFieldsNumber}
          placeholder={t("schema:expression.variables.placeholder")}
          rules={[
            {
              required: true,
              message: t("schema:expression.variables.requiredError"),
            },
          ]}
          required
          allowClear
        />
      </div>
    </>
  );
};
